import React from 'react';
import PropTypes from 'prop-types';
import DeleteRelatedButton from './buttons/DeleteRelatedButton';
import FieldTitle from 'components/aor/FieldTitle';
import HeaderColumn from 'components/ui/table/HeaderColumn';
import NoResults from 'components/form/styling/NoResults';
import Table from 'components/ui/table/Table';
import TableBodyCell from 'components/table/TableBodyCell';
import TableRow from 'components/ui/table/TableRow';
import TextField from 'components/show/TextField';
import SingleDataContainer from 'containers/Data/SingleDataContainer';
import SubcategoryField from './SubCategoryField';
import compose from 'recompose/compose';
import styled from 'styled-components';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { deleteProductRelated } from 'store/actions/products/related/deleteProductRelated';
import { fetchProductAccumulated } from 'store/actions/products/fetchProducts';

const StyledDeleteIcon = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

const ProductRelatedTable = (props) => {
    const {
        data,
        handleRemove,
        resource,
    } = props;

    if (utils.isEmpty(data)) {
        return <NoResults label='resources.products.related.no_results' />;
    }

    return (
        <Table responsive='scroll'>
            <TableRow>
                <HeaderColumn style={ { width: '40%' } } >
                    <FieldTitle
                        label='resources.products.fields.title'
                        source='productRelated'
                        resource={ resource }
                    />
                </HeaderColumn>
                <HeaderColumn style={ { width: '25%' } }>
                    <FieldTitle
                        label='resources.products.fields.category_id'
                        source='category_id'
                        resource={ resource }
                    />
                </HeaderColumn>
                <HeaderColumn style={ { width: '25%' } }>
                    <FieldTitle
                        label='resources.products.fields.subcategory_id'
                        source='subcategory_id'
                        resource={ resource }
                    />
                </HeaderColumn>
                <HeaderColumn style={ { width: '10%' } }>&nbsp;</HeaderColumn>
            </TableRow>

            { utils.map(data, function (productRelated) {
                return (
                    <SingleDataContainer
                        action={ fetchProductAccumulated }
                        id={ productRelated.related_product_id }
                        key={ productRelated.id }
                        resource='products'
                    >
                        { (renderProps) => {
                            const product = renderProps.data;

                            return (
                                <TableRow>
                                    <TableBodyCell
                                        field={ <TextField value={ product.title } /> }
                                        record={ product }
                                        source='title'
                                    />

                                    <TableBodyCell
                                        field={ <TextField value={ product.relationships.category.data.name } /> }
                                        record={ product }
                                        source='category.name'
                                    />

                                    <TableBodyCell
                                        field={
                                            <SubcategoryField
                                                id={ product.subcategory_id }
                                                parentId={ product.category_id }
                                            />
                                        }
                                        record={ product }
                                        source='subcategory_id'
                                    />

                                    <TableBodyCell
                                        field={
                                            <StyledDeleteIcon>
                                                <DeleteRelatedButton
                                                    handleRemove={ () => {
                                                        return handleRemove(productRelated.related_product_id, productRelated.id);
                                                    } }
                                                />
                                            </StyledDeleteIcon>
                                        }
                                        record={ product }
                                        resource={ resource }
                                    />
                                </TableRow>
                            );
                        } }
                    </SingleDataContainer>
                );
            }) }
        </Table>
    );
};

ProductRelatedTable.propTypes = {
    data: PropTypes.object,
    handleRemove: PropTypes.func.isRequired,
    resource: PropTypes.string.isRequired,
};

const mapStateToProps = (state, props) => {
    const { productId } = props;

    const stateResource = state.productRelated;

    return {
        data: stateResource.data[productId],
    };
};

const mapDispatchToProps = (dispatch, props) => {
    const { productId } = props;

    return {
        handleRemove: (productRelatedId, relatedId) => {
            dispatch(deleteProductRelated({
                productId: productId,
                productRelatedId: productRelatedId,
                relatedId: relatedId,
            }));
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
);

export default enhance(ProductRelatedTable);



// WEBPACK FOOTER //
// ./src/pages/products/productRelated/ProductRelatedTable.js